<div class="synonym-add-container">
    <!-- Header -->
    <div class="page-header">
        <button class="back-btn" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            <span>Volver a grupos</span>
        </button>
        <div class="header-content">
            <h1>{{ isEditing ? 'Editar Grupo de Sinónimos' : 'Crear Nuevo Grupo' }}</h1>
            <p class="subtitle">{{ isEditing ? 'Modifica el nombre, estado y sinónimos del grupo' : 'Configura un nuevo grupo de términos equivalentes' }}</p>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Cargando grupo...</p>
    </div>

    <!-- Form Container -->
    <div class="form-container" *ngIf="!isLoading">
        <!-- Group Details Card -->
        <div class="card">
            <div class="card-header">
                <h2>Información del Grupo</h2>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label for="groupName">Nombre del grupo <span class="required">*</span></label>
                    <input 
                        id="groupName"
                        type="text" 
                        placeholder="Ej: Televisores, Refrigeradores, Celulares..."
                        [(ngModel)]="group.group_name"
                        class="form-input"
                    />
                    <p class="form-hint">Nombre descriptivo que identifica este grupo de sinónimos</p>
                </div>

                <div class="form-group">
                    <label>Estado del grupo</label>
                    <div class="status-selector">
                        <button 
                            class="status-btn"
                            [class.active]="group.is_active === 1"
                            (click)="group.is_active = 1"
                        >
                            <mat-icon>check_circle</mat-icon>
                            <div class="status-info">
                                <span class="status-title">Activo</span>
                                <span class="status-desc">Se usa en búsquedas</span>
                            </div>
                        </button>
                        <button 
                            class="status-btn"
                            [class.active]="group.is_active === 0"
                            (click)="group.is_active = 0"
                        >
                            <mat-icon>pause_circle</mat-icon>
                            <div class="status-info">
                                <span class="status-title">Inactivo</span>
                                <span class="status-desc">No se usa en búsquedas</span>
                            </div>
                        </button>
                    </div>
                </div>

                <div class="form-actions">
                    <button class="btn-secondary" (click)="goBack()" [disabled]="isSaving">
                        Cancelar
                    </button>
                    <button class="btn-primary" (click)="saveGroup()" [disabled]="isSaving || !group.group_name.trim()">
                        <mat-spinner *ngIf="isSaving" diameter="18"></mat-spinner>
                        <mat-icon *ngIf="!isSaving">save</mat-icon>
                        <span>{{ isSaving ? 'Guardando...' : (isEditing ? 'Guardar cambios' : 'Crear grupo') }}</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Synonyms Card (only in edit mode) -->
        <div class="card" *ngIf="isEditing">
            <div class="card-header">
                <h2>Sinónimos</h2>
                <span class="synonym-count">{{ group.synonyms?.length || 0 }} término{{ group.synonyms?.length !== 1 ? 's' : '' }}</span>
            </div>
            <div class="card-body">
                <!-- Add Synonym Form -->
                <div class="add-synonym-section">
                    <div class="input-row">
                        <input 
                            type="text"
                            placeholder="Escribe un sinónimo y presiona Enter o click en Agregar..."
                            [(ngModel)]="newSynonymPhrase"
                            (keydown.enter)="addSynonym()"
                            [disabled]="addingSynonym"
                            class="form-input"
                        />
                        <button 
                            class="btn-primary"
                            (click)="addSynonym()"
                            [disabled]="addingSynonym || !newSynonymPhrase.trim()"
                        >
                            <mat-spinner *ngIf="addingSynonym" diameter="18"></mat-spinner>
                            <mat-icon *ngIf="!addingSynonym">add</mat-icon>
                            <span>Agregar</span>
                        </button>
                    </div>
                    <p class="form-hint">
                        <mat-icon>info</mat-icon>
                        Puedes agregar frases de múltiples palabras como "smart tv" o "refrigerador con freezer"
                    </p>
                </div>

                <!-- Synonyms List -->
                <div class="synonyms-list" *ngIf="group.synonyms && group.synonyms.length > 0">
                    <div 
                        class="synonym-item" 
                        *ngFor="let synonym of group.synonyms"
                        [class.editing]="editingSynonymId === synonym.id"
                    >
                        <!-- View Mode -->
                        <ng-container *ngIf="editingSynonymId !== synonym.id">
                            <div class="synonym-content">
                                <span class="synonym-phrase">{{ synonym.synonym_phrase }}</span>
                                <div class="synonym-meta">
                                    <span class="normalized" matTooltip="Versión normalizada">
                                        <mat-icon>transform</mat-icon>
                                        {{ synonym.normalized_phrase }}
                                    </span>
                                    <span class="word-count" *ngIf="synonym.word_count > 1" matTooltip="Cantidad de palabras">
                                        <mat-icon>notes</mat-icon>
                                        {{ synonym.word_count }} palabras
                                    </span>
                                </div>
                            </div>
                            <div class="synonym-actions">
                                <button class="icon-btn edit" (click)="startEditSynonym(synonym)" matTooltip="Editar">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button class="icon-btn delete" (click)="removeSynonym(synonym)" matTooltip="Eliminar">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </ng-container>

                        <!-- Edit Mode -->
                        <ng-container *ngIf="editingSynonymId === synonym.id">
                            <div class="edit-form">
                                <input 
                                    type="text"
                                    [(ngModel)]="editingSynonymPhrase"
                                    (keydown.enter)="saveEditSynonym(synonym)"
                                    (keydown.escape)="cancelEditSynonym()"
                                    class="form-input"
                                    autofocus
                                />
                                <div class="edit-actions">
                                    <button class="icon-btn cancel" (click)="cancelEditSynonym()" matTooltip="Cancelar">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <button class="icon-btn save" (click)="saveEditSynonym(synonym)" matTooltip="Guardar">
                                        <mat-icon>check</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Empty Synonyms State -->
                <div class="empty-synonyms" *ngIf="!group.synonyms || group.synonyms.length === 0">
                    <mat-icon>label_off</mat-icon>
                    <h3>No hay sinónimos en este grupo</h3>
                    <p>Agrega sinónimos arriba para que el grupo funcione en las búsquedas</p>
                </div>
            </div>
        </div>

        <!-- Info Card (only in create mode) -->
        <div class="info-card" *ngIf="!isEditing">
            <mat-icon>info</mat-icon>
            <div class="info-content">
                <h3>¿Cómo funcionan los sinónimos?</h3>
                <p>Después de crear el grupo, podrás agregar sinónimos. Los sinónimos son términos equivalentes que se usarán para expandir las búsquedas de los clientes.</p>
                <p><strong>Ejemplo:</strong> Si un grupo contiene "tv", "television" y "televisor", cuando un cliente busque cualquiera de estos términos, encontrará todos los productos relacionados.</p>
            </div>
        </div>
    </div>
</div>
